import React from "react";

interface PersonasSectionProps {
  personaMan?: string;
  personaWoman?: string;
}

export const PersonasSection: React.FC<PersonasSectionProps> = ({ personaMan, personaWoman }) => {
  return (
    <section className="py-32 bg-zinc-950 relative">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div>
            <span className="text-primary font-bold tracking-widest uppercase text-xs mb-2 block">
              The Simulation
            </span>
            <h2 className="text-4xl md:text-6xl font-heading font-bold text-white">
              Choose Your Journey
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-right md:text-left">
            Practice with sophisticated AI partners. They will challenge you to be your best self.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Persona Card 1 - The Philosopher */}
          <div className="group relative h-[600px] overflow-hidden rounded-[2rem] border border-white/5 hover:border-primary/30 transition-all duration-500 bg-zinc-900">
            {personaMan && (
              <img
                src={personaMan}
                alt="The Strategist"
                className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity duration-700 mix-blend-luminosity"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

            <div className="absolute bottom-0 left-0 right-0 p-10">
              <div className="text-xs font-mono text-primary mb-2 uppercase tracking-widest">
                Archetype 01
              </div>
              <h3 className="text-4xl font-heading font-bold text-white mb-2">The Philosopher</h3>
              <p className="text-zinc-300 text-lg mb-8 italic font-serif">
                "I don't want small talk. I want to know what keeps you up at night."
              </p>

              <div className="flex gap-3">
                <span className="px-3 py-1 rounded-full bg-white/10 backdrop-blur-md text-xs text-white">
                  Deep Conversation
                </span>
                <span className="px-3 py-1 rounded-full bg-white/10 backdrop-blur-md text-xs text-white">
                  Presence
                </span>
              </div>
            </div>
          </div>

          {/* Persona Card 2 - The Executive */}
          <div className="group relative h-[600px] overflow-hidden rounded-[2rem] border border-white/5 hover:border-blue-500/30 transition-all duration-500 bg-zinc-900">
            {personaWoman && (
              <img
                src={personaWoman}
                alt="The Enigma"
                className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity duration-700 mix-blend-luminosity"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

            <div className="absolute bottom-0 left-0 right-0 p-10">
              <div className="text-xs font-mono text-blue-400 mb-2 uppercase tracking-widest">
                Archetype 02
              </div>
              <h3 className="text-4xl font-heading font-bold text-white mb-2">The Executive</h3>
              <p className="text-zinc-300 text-lg mb-8 italic font-serif">
                "Confidence is quiet. Show me you can hold your ground without being loud."
              </p>

              <div className="flex gap-3">
                <span className="px-3 py-1 rounded-full bg-white/10 backdrop-blur-md text-xs text-white">
                  High Standards
                </span>
                <span className="px-3 py-1 rounded-full bg-white/10 backdrop-blur-md text-xs text-white">
                  Directness
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
